import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren, ReactNode } from "react";
import Link from "../../../../components/general/Link";
import * as s from "./MoreSalesBanner.module.scss";

type MoreSalesBannerProps = PropsWithChildren<{
	padding?: boolean;
	image: ReactNode;
	productName: string;
	price: string;
	fabric?: string;
	color: string;
	href?: string;
	outOfStock?: boolean;
}>;

const MoreSalesBanner: FC<
	React.HTMLAttributes<HTMLLIElement> & MoreSalesBannerProps
> = ({
	padding,
	image,
	productName,
	price,
	fabric,
	color,
	href,
	outOfStock = false,
	className,
	children,
	...props
}) => {
	return (
		<li
			className={cn(s.container, className, { [s.withPadding]: padding })}
			{...props}
		>
			<div className="aspect-5/7 max-w-[5rem] min-w-[5rem]">
				{href ? <Link href={href}>{image}</Link> : image}
			</div>
			<div className={s.content}>
				<div>
					<div className={s.row}>
						{href ? (
							<Link href={href} className={s.title}>
								<p>{productName}</p>
							</Link>
						) : (
							<p className={s.title}>{productName}</p>
						)}
						<h5 className={cn(s.price, { [s.outOfStock]: outOfStock })}>
							{price}
						</h5>
					</div>
					<span className={s.labels}>
						{[fabric, color].filter(Boolean).join(", ")}
					</span>
				</div>

				<div className={cn(s.row, s.cta)}>{children}</div>
			</div>
		</li>
	);
};

export default MoreSalesBanner;
